import React from 'react';
import { Link } from 'react-router-dom';

export const Logo = ({ className = '', linkTo = '/', size = 'default' }) => {
  const sizeClasses = {
    small: 'h-8',
    default: 'h-10',
    large: 'h-12'
  };

  const logoContent = (
    <img 
      src="https://customer-assets.emergentagent.com/job_lagree-connect/artifacts/4xf7zfwg_IMG_3819.jpeg"
      alt="LAGREE MVMT"
      className={`${sizeClasses[size]} w-auto object-contain ${className}`}
    />
  );

  if (linkTo) {
    return (
      <Link to={linkTo} className="flex items-center">
        {logoContent}
      </Link>
    );
  }

  return logoContent;
};

export default Logo;
